import React, { ReactNode, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, User } from '../store/auth';

interface IProps {
  element?: ReactNode;
  children?: ReactNode;
}

export function checkIsProfileIncomplete(user?: User | null): boolean {
  if (!user) return false;

  if (user?.name == null || user?.country == null || user?.yearBirth == null) {
    return true;
  }

  return false;
}

function AuthRedirectProvider({
  element,
  children,
}: IProps) {
  const { authorized, user } = useAuth();
  const location = useLocation();
  const isCreateAccountPage = location.pathname.includes('/create-account');

  const profileIncomplete = useMemo(() => checkIsProfileIncomplete(user), [user]);

  // Redirect to /create-account if profile incomplete
  if (authorized && user && profileIncomplete && !isCreateAccountPage) {
    return <Navigate to="/create-account" replace />;
  }

  // Redirects to success when profile is completed on /create-account
  if (isCreateAccountPage && authorized && user && !profileIncomplete) {
    return <Navigate to="/create-account-success" replace />;
  }

  return element || children;
}

export default AuthRedirectProvider;
